import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../components/Breadcrumb';
import Heading from '../../components/Heading';
import { BASE_URL } from '../../routes/routeConstant';
import useServices from '../../stores/useServices';
import ServiceCard from './component/ServiceCard';
import Skeleton from '../../components/ui/skeleton';
import { LanguageContext } from '../../contexts/LanguageContext';

export default function AllService() {
  const { t } = useTranslation();
  const { language } =
    useContext(LanguageContext) ||
    (() => {
      throw new Error('LanguageSwitcher must be used within a LanguageProvider');
    })();
  const lang = language === 'id';
  const breadcrumbPath = [{ name: t('navigation.home'), link: BASE_URL }, { name: t('navigation.services') }];
  const { fetchLoading, hasFetched, fetchServices, services } = useServices();

  useEffect(() => {
    if (!hasFetched) {
      fetchServices();
    }
  }, [fetchServices, hasFetched]);

  return (
    <section className="flex flex-col items-center h-full w-full gap-4 p-2 my-4 md:my-8">
      <div className="flex flex-col items-center gap-1">
        <Heading>{t('footer.services.title')}</Heading>
        <Breadcrumb backStatus="hidden" paths={breadcrumbPath} />
      </div>
      <p className="text-center w-[90%] mb-4 sm:text-base text-sm">{t('tagline.services')}</p>
      {fetchLoading ? (
        <div key="sekeleton" className="flex animate-fade-in-up flex-wrap overflow-hidden gap-2 justify-center w-[98%]">
          {Array.from({ length: 10 }).map(() => (
            <Skeleton key={Math.random()} className="w-80 shadow-md h-32" />
          ))}
        </div>
      ) : (
        <div
          key="card-service"
          className="flex animate-fade-in-up flex-wrap overflow-hidden gap-2 justify-center w-[98%]"
        >
          {services.map((srv) => (
            <ServiceCard
              key={srv.service_id}
              id={srv.service_id}
              desc={lang ? srv.description_srv_id : srv.description_srv_en || srv.description_srv_id}
              name={lang ? srv.name_srv_id : srv.name_srv_en || srv.name_srv_id}
              image={srv.image_srv || '/assets/no-data-image.svg'}
              className="w-80"
            />
          ))}
        </div>
      )}
    </section>
  );
}
